module.exports = __webpack_public_path__ + "static/absence1-66d28765ee6174b39cd2781fa372fcdb.png";